import { Router, Route, Switch, Redirect } from "react-router-dom";
import React from "react";
import MainLayout from "./containers/mainLayout";
import Login from "./containers/login";
import ForgotPassword from "./containers/forgotPassword";
import ResetPassword from "./containers/resetPassword";
import EmployeeConfirmRegistration from "./containers/employeeConfirmRegistration";
import AdminConfirmRegistration from "./containers/employeeConfirmRegistration/admin";
import ComapnyRegistration from "./containers/companyRegistration";
import VendorRegistration from "./containers/vendorRegistration";
import WithdrawApprovalRequest from "./containers/withdrawApprovalRequest";
import AppDownload from "./containers/appDownload";
import Dashboard from "./containers/dashboard";
import CompanyDashboard from "./containers/companyDashboard";
import VendorDashboard from "./containers/vendorDashboard";
import store from "./store";
import { Provider } from "react-redux";
import history from "./history";
import { canAccessBackoffice } from "./lib/permissions";

const getStoredUser = () => {
  try {
    return JSON.parse(localStorage.getItem("user"));
  } catch (e) {
    return null;
  }
};

const MainRouter = () => {
  history.listen((location, action) => {
    window.scrollTo(0, 0);
  });

  const NotAuthRoute = ({ component: Component, ...rest }) => (
    <Route
      {...rest}
      render={(props) =>
        canAccessBackoffice(getStoredUser()) ? (
          <Redirect to="/backoffice/dashboard/overview" />
        ) : getStoredUser()?.is_admin ? (
          <Redirect to="/company/dashboard/Employees" />
        ) : getStoredUser()?.is_vendor ? (
          <Redirect to="/merchant/dashboard/overview" />
        ) : getStoredUser()?.is_hr ? (
          <Redirect to="/company/dashboard/Employees" />
        ) : (
          <Component {...props} />
        )
      }
    />
  );

  const SuperAdminRoute = ({ component: Component, ...rest }) => (
    <Route
      {...rest}
      render={(props) => {
        return canAccessBackoffice(getStoredUser()) ? (
          <MainLayout>
            <Component {...props} />
          </MainLayout>
        ) : (
          <Redirect
            to={`/login${props?.location?.pathname
              ? `?redirectURI=${props.location.pathname.toLowerCase()}`
              : ""
              }`}
          />
        );
      }}
    />

  );

  const AdminRoute = ({ component: Component, ...rest }) => (
    <Route
      {...rest}
      render={(props) =>
        (
          JSON.parse(localStorage.getItem("user"))?.is_admin
          || JSON.parse(localStorage.getItem("user"))?.is_hr
        ) ? (
          <MainLayout>
            <Component {...props} />
          </MainLayout>
        ) : (
          <Redirect
            to={`/login${props?.location?.pathname
              ? `?redirectURI=${props.location.pathname.toLowerCase()}`
              : ""
              }`}
          />
        )
      }
    />
  );

  const MerchantRoute = ({ component: Component, ...rest }) => (
    <Route
      {...rest}
      render={(props) =>
        JSON.parse(localStorage.getItem("user"))?.is_vendor ? (
          <MainLayout>
            <Component {...props} />
          </MainLayout>
        ) : (
          <Redirect
            to={`/login${props?.location?.pathname
              ? `?redirectURI=${props.location.pathname.toLowerCase()}`
              : ""
              }`}
          />
        )
      }
    />
  );

  return (
    <Provider store={store}>
      <Router history={history}>
        <Switch>
          <NotAuthRoute path="/login" exact component={Login} />
          <NotAuthRoute
            path="/auth/forgot-password"
            exact
            component={ForgotPassword}
          />
          <NotAuthRoute
            path="/auth/reset-password/:tid/:uid"
            exact
            component={ResetPassword}
          />
          <NotAuthRoute
            path="/onboarding/:cid/employees/:eid"
            exact
            component={EmployeeConfirmRegistration}
          />
          <NotAuthRoute
            path="/onboarding/:cid/admins/:aid"
            exact
            component={AdminConfirmRegistration}
          />
          <NotAuthRoute
            path="/onboarding/:cid"
            exact
            component={ComapnyRegistration}
          />
          <NotAuthRoute
            path="/onboarding/vendors/:vid/:token"
            exact
            component={VendorRegistration}
          />
          <NotAuthRoute path="/app/download" exact component={AppDownload} />
          <SuperAdminRoute
            path="/backoffice/dashboard/:activeTab"
            exact
            component={Dashboard}
          />
          <SuperAdminRoute
            path="/payments/:payment_id"
            exact
            component={WithdrawApprovalRequest}
          />
          <AdminRoute
            path="/company/dashboard/:activeTab"
            exact
            component={CompanyDashboard}
          />
          <MerchantRoute
            path="/merchant/dashboard/:activeTab"
            exact
            component={VendorDashboard}
          />
          <Redirect from="/" to={"/login"}></Redirect>
        </Switch>
      </Router>
    </Provider>
  );
};

export default MainRouter;
